var _jsxFileName = "/src/main/react/src/main/app/components/login/Login.js";
import LoginForm from './LoginForm';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';
import queryString from 'query-string';
import { Q_STRING } from "../domain/constants";
import { retrieveFromQueryString } from "../../util/QueryStringUtil";
import { clearUserDataFromLocalStorage } from "../../util/StorageUtil";
const styles = {
  centeredDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: '50px',
    padding: '50px',
    height: '100%'
  },
  paddedCard: {
    padding: '20px'
  }
};
const params = new URLSearchParams(window.location.search);
class Login extends Component {
  constructor(props) {
    super(props);
    const querystringValues = queryString.parse(this.props.location.search);
    const expired = retrieveFromQueryString(Q_STRING.EXPIRED, querystringValues);
    this.state = {
      message: expired === 'true' ? 'You must log in again' : 'Please log in',
      isExpired: expired === 'true'
    };
    clearUserDataFromLocalStorage();
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredDiv,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.paddedCard,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(CardHeader, {
      title: "Welcome",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(CardContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 21
      }
    }, this.state.message !== null && /*#__PURE__*/React.createElement(Typography, {
      color: this.state.isExpired ? 'error' : 'textPrimary',
      align: "center",
      variant: 'caption',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 25
      }
    }, this.state.message), /*#__PURE__*/React.createElement(LoginForm, {
      error: params.get('error'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 25
      }
    }))));
  }
}
export default withStyles(styles)(Login);